import React from 'react'

const GroupConnectionStatus = ({ isAutoJoining, joinedGroupName }) => {
    const getStatusText = () => {
        if (isAutoJoining) return 'Connecting'
        if (joinedGroupName) return 'Connected'
        return 'Disconnected'
    }

    const getStatusColor = () => {
        if (isAutoJoining) return '#f59e0b'
        if (joinedGroupName) return '#22c55e'
        return '#ef4444'
    }

    const statusText = getStatusText()
    const statusColor = getStatusColor()

    return (
        <div className="d-flex align-items-center">
            <span
                className="me-3 fw-medium"
                style={{
                    fontSize: '1.2rem',
                    color: statusColor,
                }}
            >
                {statusText}
            </span>
            <span
                title={statusText}
                aria-label={statusText}
                style={{
                    display: 'inline-block',
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                    backgroundColor: statusColor,
                    boxShadow: '0 0 0 3px rgba(0,0,0,0.1)',
                }}
            />
        </div>
    )
}

export default GroupConnectionStatus
